export const getAllCookies = (): Array<{ name: string; value: string }> => {
  if (typeof document === "undefined") {
    return [];
  }

  return document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .filter((cookie) => cookie.length > 0)
    .map((cookie) => {
      const [name, ...valueParts] = cookie.split("=");
      const value = valueParts.join("=").trim();

      return {
        name: name?.trim() || "",
        value: value ? decodeURIComponent(value) : "",
      };
    });
};
